import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {TableConfig} from '../../../models/ui-config.models';

@Component({
  selector: 'app-calls-table',
  templateUrl: './calls-table.component.html',
  styleUrls: ['./calls-table.component.scss'],
})

export class CallsTableComponent implements OnInit {
  @Input() userType = 'learner'; // 'learner' or 'manager'
  @Input() columns: TableConfig[];
  @Output() rowClicked = new EventEmitter<any>();
  @Input() set rawData(data: any) {
    this.outputData = [...data];
  }

  protected outputData: any;

  constructor() {
  }

  ngOnInit() {
  }

  public clickHandler(event, item) {
    event.stopPropagation();

    this.rowClicked?.emit(item);
  }

  public getProgressLevelClass(percent: number): string {
    if (percent < 25) {
      return 'low';
    }
    if (percent < 50) {
      return 'mid-low';
    }
    if (percent < 75) {
      return 'mid-high';
    }
    return 'high';
  }

  protected getImprovementClass(status: string): string {
    switch (status) {
      case 'Performance Ready':
        return 'performance-ready';
      case 'Developing Strength':
        return 'developing-strength';
      case 'Earning Competence':
        return 'earning-competence';
      case 'Building Awareness':
        return 'building-awareness';
      case 'Needs Activation':
        return 'needs-activation';
      default:
        return '';
    }
  }
}
